import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import * as fromRoot from '../redux';

/**
 * Интерцептор для автоматического добавления projectId к HTTP запросам
 * Добавляет текущий выбранный projectId из состояния приложения к запросам,
 * если он не был указан явно
 */
@Injectable()
export class ProjectInterceptor implements HttpInterceptor {
  private readonly store = inject<Store<fromRoot.State>>(Store);

  /**
   * Перехватывает HTTP запросы и добавляет projectId если необходимо
   * @param request - HTTP запрос
   * @param next - Следующий обработчик в цепочке
   * @returns Observable с HTTP событием
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Если в запросе уже есть projectId, не добавляем его
    if (request.params.has('projectId')) {
      return next.handle(request);
    }

    return this.store.select(fromRoot.getProjectSelectedId).pipe(
      first(),
      switchMap((projectId: string | null) => {
        const modifiedRequest = projectId
          ? request.clone({
              setParams: { projectId },
            })
          : request;

        return next.handle(modifiedRequest);
      })
    );
  }
}
